import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22d6ddae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "姓名：", -1))
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "身份证号：", -1))
const _hoisted_6 = {
  key: 0,
  class: "form-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "被派遣单位：", -1))
const _hoisted_8 = {
  key: 1,
  class: "form-row"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "工种：", -1))
const _hoisted_10 = { class: "alert-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_alert_box = _resolveComponent("alert-box")!

  return (_openBlock(), _createBlock(_component_alert_box, {
    class: "alert-form",
    onClose: _ctx.cancel,
    width: "640px",
    dataTitle: "添加修改员工"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_input, {
            class: "form-value",
            modelValue: _ctx.info.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.info.name) = $event)),
            placeholder: "请输入员工姓名"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            class: "form-value",
            modelValue: _ctx.info.idcard,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.info.idcard) = $event)),
            placeholder: "请输入员工身份证号"
          }, null, 8, ["modelValue"])
        ]),
        (_ctx.type === 'add')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_autocomplete, {
                "fetch-suggestions": _ctx.patchAuto,
                class: "form-value",
                modelValue: _ctx.info.company_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.info.company_name) = $event)),
                placeholder: "请选择被派遣单位",
                onSelect: _ctx.selectPatch
              }, null, 8, ["fetch-suggestions", "modelValue", "onSelect"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === 'add')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_select, {
                class: "form-value",
                modelValue: _ctx.info.occupation_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.info.occupation_id) = $event)),
                placeholder: "请选择工种",
                onChange: _ctx.selectOccupation
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.occupationAutoData, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.occupation_id,
                      label: item.name + '（' + item.level + '类）',
                      value: item.occupation_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "mini-btn white",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, "取消"),
        _createElementVNode("button", {
          class: "mini-btn blue",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.workerAdd && _ctx.workerAdd(...args)))
        }, "确定")
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}